import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate, Link } from 'react-router-dom';
import Footer from './Footer.js';
import { Spinner } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import { BASE_URL } from "./Constants.js";
import { BASE_URL1 } from "./Constants.js";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Manage_DressType = () => {
    const [users, setUsers] = useState([]);
    const [selectedArea, setSelectedArea] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [genderFilter, setGenderFilter] = useState('');
    const [areasLoaded, setAreasLoaded] = useState(false);
const [dressTypesLoaded, setDressTypesLoaded] = useState(false);
const [dressSizesLoaded, setDressSizesLoaded] = useState(false);
const [dressColorsLoaded, setDressColorsLoaded] = useState(false);
    const [user, setUser] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [areas, setAreas] = useState([]); // State to store dress types
    const [dressTypes, setDressTypes] = useState([]); // State to store dress types
    const [dressSizes, setDressSizes] = useState([]); // State to store dress types
    const [dressColors, setDressColors] = useState([]); // State to store dress types
    const navigate = useNavigate();

    const handleAddStock = () => {
        navigate('/add_stock');
    };

   


    useEffect(() => {
        const fetchEmpList = async () => {
            const token = localStorage.getItem('authToken');

            if (!token) {
                setError('No token found!');
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(`${BASE_URL}emp_list_code`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();
                if (data.status && Array.isArray(data.data)) {
                    setUsers(data.data);

                    const user = data.data[0]; // assuming only one user is returned
                    setUser(user.super_admin_role);
                    // setCheckboxStates({
                    //   admin_role: user.admin_role === 'Y',
                    //   super_admin_role: user.super_admin_role === 'Y',
                    //   employee_role: user.employee_role === 'Y',
                    //   candidate_role: user.candidate_role === 'Y',
                    // });
                    //  setCheckboxStates(checkboxMap);

                } else {
                    setError('Invalid response format');
                }
            } catch (err) {
                setError('Failed to fetch employee list');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchEmpList();
    }, []);

    useEffect(() => {
        const fetchAreas = async () => {
            try {
                const token = localStorage.getItem('authToken');

                if (!token) {
                    setError('No token found!');
                    setLoading(false);
                    return;
                }

                const response = await fetch(`${BASE_URL}areas`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch areas');
                }

                const data = await response.json();

                if (data && Array.isArray(data.areas)) {
                    const activeAreas = data.areas.filter(area => area.status === 'A');
                    setAreas(activeAreas);
                    setAreasLoaded(true);
                } else {
                    setError('Invalid response format');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAreas();
    }, []);

    useEffect(() => {
        const fetchDressTypes = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log(token);

                // If no token is found, handle the error
                if (!token) {
                    setError('No token found!');
                    setLoading(false);
                    return;
                }

                const response = await fetch(`${BASE_URL}dress_types`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                console.log('Fetched dress types:', data);

                if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
                    // Filter out dress types with status 'A'
                    const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
                    setDressTypes(activeDressTypes); // Set active dress types
                    setDressTypesLoaded(true);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchDressTypes();
    }, []); // Only runs once when the component mounts

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log(token);

                // If no token is found, handle the error
                if (!token) {
                    setError('No token found!');
                    setLoading(false);
                    return;
                }

                const response = await fetch(`${BASE_URL}dress_sizes`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                console.log('Fetched data:', data);
                if (data && data.dressSizes && Array.isArray(data.dressSizes)) {
                    // Filter out users with status 'A'
                    const activeDressSizes = data.dressSizes.filter(user => user.status === 'A');
                    setDressSizes(activeDressSizes);
                     setDressSizesLoaded(true);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []); // Only runs once when the component mounts

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const token = localStorage.getItem('authToken');
                console.log(token);

                // If no token is found, handle the error
                if (!token) {
                    setError('No token found!');
                    setLoading(false);
                    return;
                }

                const response = await fetch(`${BASE_URL}dress_colors`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                console.log('Fetched data:', data);

                if (data && data.dressColors && Array.isArray(data.dressColors)) {
                    // Filter out users with status 'A'
                    const activeDressColors = data.dressColors.filter(user => user.status === 'A');
                    setDressColors(activeDressColors);
                    setDressColorsLoaded(true);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []); // Only runs once when the component mounts

    // Function to get the dress type name by ID
    const getAreaName = (id) => {
  const area = areas.find(a => String(a.id) === String(id));
  return area ? area.area : 'Unknown';
};

const getDressTypeName = (id) => {
  const type = dressTypes.find(t => String(t.id) === String(id));
  return type ? type.dress_type : 'Unknown';
};

const getDressSizeName = (id) => {
  const size = dressSizes.find(s => String(s.id) === String(id));
  return size ? size.dress_size : 'Unknown';
};

const getDressColorName = (id) => {
  const color = dressColors.find(c => String(c.id) === String(id));
  return color ? color.dress_color : 'Unknown';
};



   useEffect(() => {
  if (areasLoaded && dressTypesLoaded && dressSizesLoaded && dressColorsLoaded) {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}stocks`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        if (data && data.stocks && Array.isArray(data.stocks)) {
          setUsers(data.stocks);
          setFilteredUsers(data.stocks);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }
}, [areasLoaded, dressTypesLoaded, dressSizesLoaded, dressColorsLoaded]);


    const handleSearch = (e) => {
        setSearchQuery(e.target.value.toLowerCase().trim());
    };
    useEffect(() => {
  if (
    areas.length === 0 ||
    dressTypes.length === 0 ||
    dressSizes.length === 0 ||
    dressColors.length === 0
  ) {
    return; // wait until all data is loaded
  }

  let filteredData = users.filter((user) =>
    getAreaName(user.area_id).toLowerCase().includes(searchQuery) ||
    getDressTypeName(user.dress_type).toLowerCase().includes(searchQuery) ||
    getDressSizeName(user.dress_size).toLowerCase().includes(searchQuery) ||
    getDressColorName(user.dress_color).toLowerCase().includes(searchQuery) ||
    (user.gnr_number || '').toLowerCase().includes(searchQuery)
  );

  if (genderFilter) {
    filteredData = filteredData.filter(user => user.gender === genderFilter);
  }

  if (fromDate) {
    const from = new Date(fromDate);
    filteredData = filteredData.filter(user => {
      const createdAt = new Date(user.created_at);
      return !isNaN(createdAt) && createdAt >= from;
    });
  }

  if (toDate) {
    const to = new Date(toDate);
    filteredData = filteredData.filter(user => {
      const createdAt = new Date(user.created_at);
      return !isNaN(createdAt) && createdAt <= to;
    });
  }

  if (selectedArea) {
    filteredData = filteredData.filter(user => String(user.area_id) === String(selectedArea));
  }

  setFilteredUsers(filteredData);
}, [searchQuery, genderFilter, fromDate, toDate, selectedArea, users, areas, dressTypes, dressSizes, dressColors]);



    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Reset to the first page on change of items per page
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);



    if (loading) {
        return (
            <div className="loading-container">
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <Alert variant="danger">{error}</Alert>
            </div>
        );
    }

    const handleAreaFilter = (areaId) => {
        setSelectedArea(areaId);

        const baseFiltered = searchQuery === '' ? users : users.filter((user) =>
            getAreaName(user.area_id).toLowerCase().includes(searchQuery) ||
            getDressTypeName(user.dress_type).toLowerCase().includes(searchQuery) ||
            getDressSizeName(user.dress_size).toLowerCase().includes(searchQuery) ||
            getDressColorName(user.dress_color).toLowerCase().includes(searchQuery) ||
            user.gnr_number.toLowerCase().includes(searchQuery)
        );

        if (areaId === '') {
            setFilteredUsers(baseFiltered);
        } else {
            const areaFiltered = baseFiltered.filter((user) => String(user.area_id) === String(areaId));
            setFilteredUsers(areaFiltered);
        }
    };


    const exportToExcel = () => {
        const dataToExport = users.map((item, index) => ({
            "S/N": indexOfFirstItem + index + 1,
            "gender": item.gender,
            "area": getAreaName(item.area_id),
            "Dress Type": getDressTypeName(item.dress_type),
            "Size": getDressSizeName(item.dress_size),
            "Color": getDressColorName(item.dress_color),
            "Quantity": item.quantity,
            "Created At": item.created_at,
            "created_by": item.created_by
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Data");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(dataBlob, 'stock_data.xlsx');
    };
    const handleToggleSidebar = () => {
        if (window.innerWidth >= 992) {
            setIsSidebarOpen(prev => !prev);
        }
    };


    return (
        <>
            <div className="page-wrapper">
  <HeaderMobile />
  <Sidebar isOpen={isSidebarOpen} />
  <div
    className="page-container"
    style={{
      marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
      transition: 'margin-left 0.3s ease',
    }}
  >
    <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
    <div className="main-content">
      <div className="section__content section__content--p30">
        <div className="container-fluid">
          {/* Filter Section */}
          <div className="row g-3 mb-4">
            <div className="col-md-auto">
              <select className="form-control" onChange={(e) => handleAreaFilter(e.target.value)} value={selectedArea}>
                <option value="">All Locations</option>
                {areas.map((area) => (
                  <option key={area.id} value={area.id}>{area.area}</option>
                ))}
              </select>
            </div>

            <div className="col-md-auto">
              <select className="form-control" value={genderFilter} onChange={(e) => setGenderFilter(e.target.value)}>
                <option value="">All Genders</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>

            <div className="col-md-auto">
              <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            </div>

            <div className="col-md-auto">
              <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
            </div>

            <div className="col-md-auto">
              <button className="btn btn-success" onClick={exportToExcel}>Export to Excel</button>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex justify-content-between align-items-center mb-3">
                {user === 'Y' && (
                  <button className="btn btn-primary btn-lg" onClick={handleAddStock}>
                    <i className="fas fa-plus"></i> Add Stock
                  </button>
                )}

                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Dress Type"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                  <div className="d-flex align-items-center">
                    <label htmlFor="rowsPerPage" className="form-label me-2">Rows:</label>
                    <select
                      id="rowsPerPage"
                      className="form-control"
                      style={{ width: 'auto' }}
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="table-responsive table--no-card m-b-30">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>S/N</th>
                      <th>Area</th>
                      <th>Gender</th>
                      <th>Dress Type</th>
                      <th>Size</th>
                      <th>Color</th>
                      <th>Quantity</th>
                      <th>GRN Number</th>
                      <th>GRN Image</th>
                      <th>Created At</th>
                      <th>Created By</th>
                      {user === 'Y' && (<th>Edit</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.length > 0 ? (
                      currentUsers.map((item, index) => (
                        <tr key={item.id}>
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td>{item.area_id ? getAreaName(item.area_id) : 'Unknown'}</td>
                          <td>{item.gender}</td>
                          <td>{item.dress_type ? getDressTypeName(item.dress_type) : 'Unknown'}</td>
                          <td>{item.dress_size ? getDressSizeName(item.dress_size) : 'Unknown'}</td>
                          <td>{item.dress_color ? getDressColorName(item.dress_color) : 'Unknown'}</td>
                          <td>{item.quantity}</td>
                          <td>{item.gnr_number}</td>
                          <td>
                            {item.gnr_image ? (() => {
                              const fileExtension = item.gnr_image.split('.').pop().toLowerCase();
                              const fileUrl = `${BASE_URL1}/uploads/gnr_images/${item.gnr_image}`;
                              if (fileExtension === 'pdf') {
                                return (
                                  <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-file-pdf-o"></i>
                                  </a>
                                );
                              } else {
                                return (
                                  <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                    <img src={fileUrl} alt="GNR" style={{ height: '40px', borderRadius: '4px' }} />
                                  </a>
                                );
                              }
                            })() : 'No Image'}
                          </td>
                          <td>{item.created_at?.slice(0, 16)}</td>
                          <td>{item.created_by}</td>
                          {user === 'Y' && (
                            <td>
                              <Link to={`/edit_stock/${item.id}`}>
                                <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green' }}></i>
                              </Link>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="6" className="text-center">No stock data found</td></tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="btn btn-sm btn-outline-secondary mx-1"
                >
                  Prev
                </button>

                {[...Array(totalPages).keys()].map(pageNumber => (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber + 1)}
                    className={`btn btn-sm ${currentPage === pageNumber + 1 ? 'btn-primary' : 'btn-outline-secondary'} mx-1`}
                  >
                    {pageNumber + 1}
                  </button>
                ))}

                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="btn btn-sm btn-outline-secondary mx-1"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</div>

        </>
    );
};

export default Manage_DressType;
